import type { CartLine } from '../types/models';

function isCartLine(value: unknown): value is CartLine {
  if (typeof value !== 'object' || value === null) return false;
  const line = value as CartLine;
  return (
    typeof line.productId === 'string' &&
    typeof line.vendorId === 'string' &&
    typeof line.title === 'string' &&
    typeof line.quantity === 'number' &&
    typeof line.priceCents === 'number'
  );
}

/** Coerce persisted/API cart line payloads into a CartLine array. */
export function normalizeCartLines(value: unknown): CartLine[] {
  if (value == null) return [];
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return [];
    try {
      return normalizeCartLines(JSON.parse(trimmed));
    } catch {
      return [];
    }
  }
  if (Array.isArray(value)) return value.filter(isCartLine);
  if (typeof value === 'object') return isCartLine(value) ? [value] : [];
  return [];
}
